<app-tables
  [tableHeader]="tableHeader"
  [url]="url"
  [columns]="columns"
  [filters]="filters"
  [type]="'branchReportList'"
></app-tables>

<!-- 
[data]="data"
[totalCount]="totalCount"
(filtersChange)="onChangeFilterValues($event.filters, $event.sort)"
(onPageChange)="changePage($event)"
[totalPage]="totalPage" -->
